const rootActionPath = 'core/Onboarding';

export const ONBOARDING_SCREEN_VIEW = `${rootActionPath}/screen/VIEW`;
export const EMAIL_OPT_IN = `${rootActionPath}/emailOptIn/CLICK`;
export const FAVORITES_DONE_CLICK = `${rootActionPath}/favoritesDone/CLICK`;
export const ONBOARDING_BUTTON_CHOICE_CLICK = `${rootActionPath}/onboardingButtonChoice/CLICK`;
export const CLOSE_BUTTON_CLICK = `${rootActionPath}/closeButton/CLICK`;
export const ACQUISITION_DONE_CLICK = `${rootActionPath}/acquisitionDone/CLICK`;
